export const englishHousehold = {
  templateId: 'household',
  language: 'en',
  name: 'Household Essentials (English)',
  description: 'Common household items and cleaning supplies',
  icon: '🏠',
  categories: [
    {
      name: 'Cleaning Supplies',
      items: [
        'All-purpose cleaner',
        'Bleach',
        'Bathroom cleaner',
        'Floor cleaner',
        'Glass cleaner',
        'Washing up liquid',
        'Fabric softener',
        'Washing powder',
        'Laundry detergent',
        'Stain remover',
        'Toilet cleaner',
        'Kitchen spray',
        'Antibacterial wipes',
        'Vacuum bags',
        'Bin bags'
      ]
    },
    {
      name: 'Paper Products',
      items: [
        'Toilet paper',
        'Kitchen roll',
        'Tissues',
        'Paper towels',
        'Napkins',
        'Paper plates',
        'Paper cups',
        'Aluminum foil',
        'Cling film',
        'Parchment paper',
        'Freezer bags',
        'Sandwich bags'
      ]
    },
    {
      name: 'Personal Care',
      items: [
        'Toothpaste',
        'Toothbrush',
        'Shampoo',
        'Conditioner',
        'Body wash',
        'Soap',
        'Deodorant',
        'Razor',
        'Shaving cream',
        'Moisturizer',
        'Face wash',
        'Sunscreen',
        'Vitamins',
        'Aspirin',
        'Bandages'
      ]
    },
    {
      name: 'Batteries & Electronics',
      items: [
        'AA batteries',
        'AAA batteries',
        'Phone charger',
        'Light bulbs',
        'Extension cord',
        'USB cable',
        'Memory card',
        'Headphones',
        'Power bank',
        'Screen cleaner'
      ]
    },
    {
      name: 'Pet Supplies',
      items: [
        'Dog food',
        'Cat food',
        'Pet treats',
        'Cat litter',
        'Dog toys',
        'Pet shampoo',
        'Fish food',
        'Bird seed',
        'Pet bedding',
        'Leash'
      ]
    },
    {
      name: 'Office & School',
      items: [
        'Pens',
        'Pencils',
        'Notebooks',
        'Printer paper',
        'Ink cartridges',
        'Staples',
        'Paper clips',
        'Sticky notes',
        'Folders',
        'Envelopes',
        'Stamps',
        'Markers',
        'Highlighters',
        'Ruler',
        'Eraser'
      ]
    }
  ]
};
